// import bus from "/src/utils/event_bus";
// import send_backend_event from "/src/utils/events";

import { init_session_watchers } from './session'
import { init_app_watchers } from "./app";


// This is called explicitly from stores/index.js


export default function () {
    // MODULES
    init_app_watchers()
    init_session_watchers()


    // ROOT WATCHERS
    // bus.on("back_event", send_backend_event);

}



// CAUTION !!!
// IF YOU ARE LOOKING TO AUTOMATIC DISPATCHERS (ON URL/ROUTE CHANGE)
// TAKE A LOOK AT "asyncStoreDispatcher" IN "router/guards.js"